<template>
  <div>
    <Head title="Gjendja" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/shofer-shperndares/barazimet-me-baze">Barazimet</Link>
      <span class="text-indigo-400 font-medium">/</span> Gjendja aktuale
    </h1>
    <div class="max-w-lg bg-white rounded-md shadow overflow-hidden">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="font-bold">Gjithsejt dërgesa:</label>
            <p>{{balance.shipping_orders + balance.pending_orders + balance.delivered_orders + balance.cancelled_orders}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="font-bold">Në shpërndarje:</label>
            <p>{{balance.shipping_orders}}</p>
          </div>


          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="font-bold">Në pritje:</label>
            <p>{{balance.pending_orders}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="font-bold">Sukses:</label>
            <p>{{balance.delivered_orders}}</p>
          </div>



          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="font-bold">Të anuluara:</label>
            <p>{{balance.cancelled_orders}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="font-bold">Të anuluara:</label>
            <p>{{balance.cancelled_orders}}</p>
          </div>

<!--          <div class="pb-8 pr-6 w-full lg:w-1/2">-->
<!--            <label class="font-bold">Kthime të mjeteve paguara nga shoferi:</label>-->
<!--            <p>{{moneyReturns.data.length}}</p>-->
<!--          </div>-->

<!--          <div class="pb-8 pr-6 w-full lg:w-1/2">-->
<!--            <label class="font-bold">Totali i kthimeve të mjeteve:</label>-->
<!--            <currency-number-format :number="`${balance.money_return_cost}`"></currency-number-format>-->

<!--          </div>-->

          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="font-bold">Totali për dorëzim:</label>
            <currency-number-format :number="`${balance.expected_amount}`"></currency-number-format>
          </div>
        </div>
    </div>

    <div class="flex items-center mb-6">
      <h2 class="mt-12 text-2xl font-bold">Dërgesat e pabarazuara</h2>
    </div>

    <search-input v-model="form.search" class="mr-4 mb-4 w-full max-w-md" @reset="reset"></search-input>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
<!--          <th class="pb-4 pt-6 px-2">-->
<!--            <input :checked="allOrdersSelected" @click="selectAllOrders" class="flex items-center  px-2 py-4" type="checkbox">-->
<!--          </th>-->
          <th class="pb-4 pt-6 px-2"></th>
          <th class="pb-4 pt-6 px-2">ID</th>
          <th class="pb-4 pt-6 px-2">Statusi</th>
          <th class="pb-4 pt-6 px-2">Biznesi shitës</th>
          <th class="pb-4 pt-6 px-2">Pika marrëse</th>
          <th class="pb-4 pt-6 px-2">Emri i blerësit</th>
          <th class="pb-4 pt-6 px-2">Telefoni i blerësit</th>
          <th class="pb-4 pt-6 px-2">Produkti</th>
          <th class="pb-4 pt-6 px-2">Sasia</th>
          <th class="pb-4 pt-6 px-2">Madhësia e pakos</th>
          <th class="pb-4 pt-6 px-2">Çmimi</th>
          <th class="pb-4 pt-6 px-2">Qyteti</th>
          <th class="pb-4 pt-6 px-2">Krijuar më</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="order in orders.data" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100">

<!--          <td class="border-t px-2">-->
<!--            <input v-model="order.selected" :value="order.id" class="flex items-center  px-2 py-4" type="checkbox">-->
<!--          </td>-->

          <td class="w-px border-t">
            <a class="flex items-center  px-2 py-4" :href="`/shofer-shperndares/dergesat/${order.id}`" target="_blank" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </a>
          </td>

          <td class="border-t px-2">
            {{ order.id }}
            <icon v-if="order.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
            <small v-if="order.is_change" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">NDËRRIM</small>
            <small v-if="order.is_recreated" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">RINISJE</small>
            <small v-if="order.parent_id" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">BASHKIM</small>
          </td>
          <td class="border-t px-2">
              <span class="mx-0.5 px-2 py-1 rounded-md text-white" v-bind:class="getOrderStatusColor(order.status.id)">
                {{ order.status.name }}</span>
          </td>
          <td class="border-t px-2">
            {{ order.business.name }}
          </td>
          <td class="border-t px-2">
            {{ order.location.name }}
          </td>
          <td class="border-t px-2">
            {{ order.name }}
          </td>
          <td class="border-t px-2">
            {{ order.phone }}
          </td>
          <td class="border-t px-2">
            {{ order.product_name }}
          </td>
          <td class="border-t px-2">
            {{ order.quantity }}
          </td>
          <td class="border-t px-2">
            {{ order.package_size.name }}
          </td>
          <td class="border-t px-2">
            {{ order.product_price }}
          </td>
          <td class="border-t px-2">
            {{ order.city.name }}
          </td>
          <td class="border-t px-2">
            {{ order.hr_created_at }}
          </td>
        </tr>
        <tr v-if="orders.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="14">Nuk u gjet asnje dërgesë.</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div  class="flex items-center mb-6">
      <h2 class="mt-12 text-2xl font-bold">Kthimet e mjeteve</h2>
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6"></th>
          <th class="pb-4 pt-6 px-6">ID</th>
          <th class="pb-4 pt-6 px-6">Dërgesa</th>
          <th class="pb-4 pt-6 px-6">Kthimi i dërgesës</th>
          <th class="pb-4 pt-6 px-6">Biznesi shitës</th>
          <th class="pb-4 pt-6 px-6">Pika marrëse</th>
          <th class="pb-4 pt-6 px-6">Shuma e mjeteve</th>
          <th class="pb-4 pt-6 px-6">Posta</th>
          <th class="pb-4 pt-6 px-6">Emri i blerësit</th>
          <th class="pb-4 pt-6 px-6" >Telefoni i blerësit</th>
          <th class="pb-4 pt-6 px-6" >Qyteti</th>
          <th class="pb-4 pt-6 px-6" >Statusi</th>
          <th class="pb-4 pt-6 px-6" >Krijuar më</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="moneyReturn in moneyReturns.data" :key="moneyReturn.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="w-px border-t">
            <a class="flex items-center  px-2 py-4" :href="`/admin/mjetet/${moneyReturn.id}`" target="_blank" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </a>
          </td>
          <td class="border-t px-2">
            {{ moneyReturn.id }}
          </td>
          <td class="border-t px-2">
            <a class="flex items-center px-6 py-4 focus:text-indigo-500" target="_blank" :href="`/admin/dergesat/${moneyReturn.order_id}`">
              {{ moneyReturn.order_id }}
            </a>
          </td>
          <td  class="border-t px-2">
            <a  class="flex items-center px-6 py-4 focus:text-indigo-500" target="_blank" :href="`/admin/nderrimet/${moneyReturn.order_change_id}`">
              {{ moneyReturn.order_change_id}}
            </a>
          </td>
          <td  class="border-t px-2">
            {{ moneyReturn.business }}
          </td>
          <td class="border-t px-2">
            {{ moneyReturn.paid_by_seller ? moneyReturn.location : 'Mjetet te mirren nga posta' }}
          </td>
          <td class="border-t px-2">
            {{ moneyReturn.amount }}
          </td>
          <td class="border-t px-2">
            {{ moneyReturn.shipping_price }}
          </td>
          <td class="border-t px-2">
            {{ moneyReturn.client }}
          </td>
          <td class="border-t px-2">
            {{ moneyReturn.phone }}
          </td>
          <td class="border-t px-2">
            {{ moneyReturn.city }}
          </td>
          <td class="border-t px-2">
            <span class="mx-0.5 px-2 py-1 rounded-md text-white" v-bind:class="getMoneyReturnStatusColor(moneyReturn.status_id)">{{ moneyReturn.status }}</span>
          </td>
          <td class="border-t px-2">
            {{ moneyReturn.hr_created_at }}
          </td>
        </tr>
        <tr v-if="moneyReturns.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">Nuk u gjet asnjë rekord.</td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import axios from 'axios'
import Icon from '@/Shared/Icon'
import Dropdown from '@/Shared/Dropdown'
import CurrencyNumberFormat from '@/Shared/CurrencyNumberFormat'
import SearchInput from '@/Shared/SearchInput'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import TextareaInput from '@/Shared/TextareaInput'
import Modal from '@/Shared/Modal'

export default {
  components: {
    SearchInput,
    CurrencyNumberFormat,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    Icon,
    Dropdown,
    TextareaInput,
    Modal
  },
  layout: Layout,
  props:{
    deliveryDrivers: Array,
    orders: Object,
    moneyReturns: Object,
    filters: Object,
    balance: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        search: this.filters.search,
      }),
    }
  },
  // mounted() {
  //   this.orders.data.forEach((order) => order['selected'] = false);
  // },
  // computed:{
  //   allOrdersSelected(){
  //     return this.orders.data.every(order => order.selected)
  //   }
  // },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/shofer-shperndares/barazimet-me-baze/gjendja',pickBy(this.form),{
          preserveScroll: true,
          preserveState: true,
        })
      }, 150)
    },
    // orders: {
    //   handler() {
    //     this.barazimForm.currentOrderSelections = this.orders.data
    //       .filter( order => order.selected )
    //       .map( order => order.id )
    //       .toString();
    //   },
    //   deep: true
    // },
  },
  methods: {
    reset(){
      this.form.search = ''
    },
    // selectAllOrders(){
    //   let allS = this.allOrdersSelected;
    //   this.orders.data.forEach(order => order.selected = !allS)
    // },
    getOrderStatusColor(statusId){
      let statusColor = 'bg-indigo-500'
      if(statusId === 1)
        statusColor = 'bg-yellow-500'

      if(statusId === 3)
        statusColor = 'bg-orange-500'

      if(statusId === 4)
        statusColor = 'bg-indigo-900'

      if(statusId === 5)
        statusColor = 'bg-green-500'

      if(statusId === 6)
        statusColor = 'bg-yellow-700'

      if(statusId === 7)
        statusColor = 'bg-red-500'

      if(statusId === 8)
        statusColor = 'bg-gray-400'

      if(statusId === 9)
        statusColor = 'bg-green-500'

      return statusColor
    },
    getMoneyReturnStatusColor(moneyReturnStatusId){
      let color = 'bg-indigo-500'
      if (moneyReturnStatusId === 1)
        color = 'bg-yellow-500'

      if (moneyReturnStatusId === 3)
        color = 'bg-orange-500'

      if (moneyReturnStatusId === 4)
        color = 'bg-indigo-900'

      if (moneyReturnStatusId === 5)
        color = 'bg-green-500'

      if (moneyReturnStatusId === 6)
        color = 'bg-red-500'


      return color
    },
  },

}
</script>
